'use client';

import { Button, Stack, Text, Title, rem } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import NoteIcon from '@/assets/icons/note-pencil-icon.svg';
import CustomComponent from '@/components/modals/modal-custom-drawer';
import NoteContent from '@/components/modals/note-modal/note-content';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

export default function BookingNote() {
  const isMobile = useIsMobile();
  const tBooking = useTranslations('booking');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const { remarks, isLoadingStore } = useBookingStore((state) => state);

  return (
    <>
      <Button
        disabled={isLoadingStore}
        loading={isLoadingStore}
        fullWidth
        h={56}
        radius={rem(8)}
        p={isMobile ? rem(12) : rem(16)}
        onClick={() => {
          open();
        }}
        variant="white"
        leftSection={<NoteIcon />}
        justify="space-between"
        styles={{
          root: {
            border: `1px solid var(--mantine-color-neutral-2)`,
          },
          label: {
            width: '100%',
          },
        }}
      >
        <Stack gap={rem(4)} ta="left" w="80%">
          {remarks ? (
            <Text size={isMobile ? 'sm' : 'md'} fw={500} c="neutral.6" truncate>
              {remarks}
            </Text>
          ) : (
            <>
              <Title order={isMobile ? 6 : 5} c="neutral.6" fw={600}>
                {tBooking('note.note_title')}
              </Title>
            </>
          )}
        </Stack>
      </Button>
      <CustomComponent
        title={tBooking('note.note_title')}
        isOpen={isOpen}
        onClose={close}
        optionStyle={{
          headerStyle: {
            minHeight: rem(56),
            borderBottom: '1px solid var(--mantine-color-neutral-0)',
          },
        }}
      >
        <NoteContent onClose={close} />
      </CustomComponent>
    </>
  );
}
